module.exports = __webpack_public_path__ + "static/university.6b0f6337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/university.jpg
// module id = 7152
// module chunks = 191283472321578